/**
 * Ambiente da SPA (build-time via Vite).
 * Fonte: ``VITE_ENVIRONMENT`` (alinhada a ``ENVIRONMENT`` do backend: dev|ist|uat|prd).
 */

export function rawAppEnvironment() {
  return String(
    import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || "development"
  )
    .trim()
    .toLowerCase();
}

/** Código normalizado: ``prd`` | ``dev`` | ``ist`` | ``uat`` | outro slug. */
export function resolveAppEnvironmentCode() {
  const raw = rawAppEnvironment();
  if (raw === "prd" || raw === "production") return "prd";
  if (raw === "ist") return "ist";
  if (raw === "uat") return "uat";
  if (raw === "dev" || raw === "development") return "dev";
  return raw || "dev";
}

export function isProductionAppEnvironment() {
  return resolveAppEnvironmentCode() === "prd";
}

/**
 * Rótulo para badge (ex.: ``DEV``). ``null`` em produção — não mostrar.
 */
export function appEnvironmentBadgeLabel() {
  if (isProductionAppEnvironment()) return null;
  return resolveAppEnvironmentCode().toUpperCase();
}
